export const EVENTS = {
  SHOW_FORCE_SELECTION: 'SHOW_FORCE_SELECTION',
  LOAD_FARE_PRICE: 'LOAD_FARE_PRICE',
};
